import React from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {CtaButton} from '@optimaxdev/design-system';

import {shallowEqual, useDispatch, useSelector} from 'react-redux';

import {AnyAction} from 'redux';

import {EyeExamPopupContent} from 'components/success/contacts/eyeExamPopupContent/eyeExamPopupContent';

import {TYP_CONTACT_LENSES} from 'constants/analytics/events/typ';
import {CL_RX_METHOD, VISTA_PLUS} from 'constants/success';
import {ApplicationStoreType} from 'desktop/store';
import {getLabel} from 'libs/success/helpers/helpers';
import {FieldType} from 'types/successPage';

import {getDrawerState} from '../../../selectorsV2';
import {postEyeExam} from '../../../store/actions/orderItems/orderItems';
import {getSuccessPageItems} from '../../../store/selectors/orderItems/orderItems';
import {getOrderLoading} from '../../../store/selectors/orderStatus/orderStatus';
import {ScreenWrapper} from '../screenWrapper/screenWrapper';
import {VisiblyButton} from '../visiblyButton/visiblyButton';

/**
 * Eye exam section
 */
export const EyeExam = () => {
    const dispatch = useDispatch();
    const {isLoading, item, items} = useSelector(
        (store: ApplicationStoreType) => ({
            isLoading: getOrderLoading(store),
            item: getDrawerState(store).item,
            items: getSuccessPageItems(store) as FieldType[],
        }),
        shallowEqual,
    );

    const id = Number(item?.id);
    const isVista = item?.product?.brand.name === VISTA_PLUS;

    const sendEyeExam = () => {
        sendDesktopAnalyticsEvent(TYP_CONTACT_LENSES, getLabel(CL_RX_METHOD.EYE_EXAM, true));
        dispatch(postEyeExam({items, orderId: id}) as unknown as AnyAction);
    };

    const Buttons = (
        <>
            <VisiblyButton />
            <CtaButton
                colorName="secondary"
                isLoading={isLoading}
                onClick={sendEyeExam}
                variant="ghost"
            >
                Send Vision Test to My Email
            </CtaButton>
        </>
    );

    return (
        <ScreenWrapper buttons={Buttons}>
            <EyeExamPopupContent isVista={isVista} />
        </ScreenWrapper>
    );
};
